// IEC 60757 "Code for designation of colours" — the international letter codes
// printed on cables and wiring worldwide. This is REFERENCE DATA, not styling:
// the swatch beside a product's colour attribute paints the colour the tenant's
// cable actually is, so it can no more come from the design tokens than a
// country flag could. It lives in its own `.ts` data module for exactly that
// reason — presentation colour belongs to `styles/tokens.css` and nowhere else
// (design-system spec §2/§4 check 1), and mixing a data table of wire colours
// into a component file blurs the two.
//
// Doctrine rule 5 note: this is an INTERNATIONAL STANDARD, not one vertical's
// invention, so it is not vertical-specific code. Which attribute is a colour
// field is still data — the schema's `ui_hints.swatches` decides.

/** IEC letter code → the CSS colour that code designates. */
export const IEC_60757: Readonly<Record<string, string>> = {
  BK: "#111111", // black
  BN: "#795548", // brown
  RD: "#e53935", // red
  OG: "#fb8c00", // orange
  YE: "#fdd835", // yellow
  GN: "#43a047", // green
  BU: "#1e88e5", // blue
  VT: "#8e24aa", // violet
  GY: "#9e9e9e", // grey
  WH: "#fafafa", // white
  PK: "#ec407a", // pink
  TQ: "#26c6da", // turquoise
  SR: "#c0c0c0", // silver
  GD: "#d4af37", // gold
};

/** CSS colour keywords a tenant may type directly into a colour attribute. */
export const CSS_COLOUR_NAMES: ReadonlySet<string> = new Set([
  "black",
  "white",
  "red",
  "green",
  "blue",
  "yellow",
  "orange",
  "purple",
  "violet",
  "brown",
  "grey",
  "gray",
  "pink",
  "silver",
  "gold",
  "cyan",
  "magenta",
  "turquoise",
]);
